import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Deatils.scss";
import { useParams } from "react-router-dom";
import Image from "react-bootstrap/Image";
import { NotificationManager } from "react-notifications";
import { getblogsByid } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";
import { Tag } from "../../utils/GTMPageTag";

const Deatils = () => {
  const {hostLanguage} = useLangContext();
  const [viewData,setViewData] = useState();
  const { id } = useParams();
  Tag("Blog - Deatils -> " + id)

  
  const handleRecordView = useCallback(async(record_id) => {
    try
    {
      let apiRes = await getblogsByid(record_id,hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setViewData(responseData.data[0]);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
        // NotificationManager.error('Something went wrong!', '',2000);
    }
  },[hostLanguage]);

  const formatDate = (inputDate) => {

    const date = new Date(inputDate);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-GB', options).replace(/\//g, '.');
  
  }

  useEffect(()=>{
    // console.warn(state?.id)
    if(id !== undefined)
    {
      sessionStorage.setItem('blogId', JSON.stringify(id));
      handleRecordView(id);
    }
    else
    {
      let state_id = sessionStorage.getItem('blogId');
      handleRecordView(parseInt(state_id));
    }
  },[handleRecordView, id]);

  const getBannerImgLink = (img_link) => {
    try
    {
      let base_url = 'https://cleverdomizil.ch';
      let url = base_url + img_link?.split("httpdocs")[1];
      return url
    }
    catch(error)
    {
      console.error(error);
    }
  }
  
  return (
    <>
      {viewData !== undefined && (
        <div className="BlogDeatilsBody">
          <div className="BlogDeatilsInfo">
            <div className="BlogDeatilsInfoImg">
              <Image src={getBannerImgLink(viewData?.image)} className="BlogHero" alt="BlogHero" fluid />
            </div>

            <div className="BlogDeatilsInfoTxt">
              <Container>
                <Row>
                  <Col sm={12}>
                    <h5>{formatDate(viewData?.created_at)}</h5>
                    <h4>{viewData?.title}
                    </h4>
                    <div dangerouslySetInnerHTML={{ __html: viewData?.description }} />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Deatils;
